import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "./redux/activePackagesSaga";

import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";

import UpdateBtns from "./smartComponents/UpdateBtns";
import DataPoints from "./smartComponents/DataPoints";
import SingleDatePicker from "./smartComponents/SingleDatePicker";
import DetailsTable from "./smartComponents/DetailsTable";
import ActivePackagesView from "./smartComponents/ActivePackagesView";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import DatePicker from "./smartComponents/DatePicker";
import TrendLineChart from "./smartComponents/TrendLineChart";

import "./activePackagesModule.scss";

export const ActivePackagesModule = (props) => {
  const dispatch = useDispatch();
  const {
    isLoading,
    initialRequest,
    updatesLoading,
    selectedFilters: { moduleView }
  } = useSelector((state) => state.activePackages);

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser(props));
    }
  }, []);

  return (
    <div id="activePackagesModule">
      <SectionToggle
        autoHeight
        isLoading={isLoading}
        title="Active Packages"
        learnMore={<ActivePackagesView />}
        content={
          moduleView.id === "details" ? (
            <>
              <div className="top__filters details edit-selections-bar">
                <div className="top__filters-right">
                  <SingleDatePicker />
                </div>
                <UpdateBtns />
              </div>
              {updatesLoading ? (
                <LoadingAnimation text="Updating data..." />
              ) : (
                <>
                  <DataPoints />
                  <DetailsTable />
                </>
              )}
            </>
          ) : (
            <>
              <div className="top__filters trend edit-selections-bar">
                <div className="top__filters-right">
                  <CustomDateRanges />
                  <DatePicker />
                </div>
                <UpdateBtns />
              </div>
              {updatesLoading ? <LoadingAnimation text="Updating data..." /> : <TrendLineChart />}
            </>
          )
        }
      />
    </div>
  );
};
